// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__T1NM8","toggle":"styles_toggle__19irT","preview":"styles_preview__3lDCx"};